import React from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import className from 'classnames'
import Head from 'next/head'
import dynamic from 'next/dynamic'

import {t, axios} from '@lib/helpers'

const DualSlide = dynamic(() => import('@components/DualSlide'))
const Meta = dynamic(() => import('@components/Meta'))
const ProductItem = dynamic(() => import('@components/ProductItem'))

const Products = ({products = []}) => {
  return (
    <React.Fragment>
      <Meta title={`${t('pages.products.title')} – ${t('layout.title')}`} />

      <div className='Products'>
        <DualSlide>
          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--h1': true,
              'DualSlide__wrapper--h1--red': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h2
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.products.dualslide.0.h2'),
                }}
              />

              <p className='DualSlide__p'>
                {t('pages.products.dualslide.0.p')}
              </p>
            </div>

            <div className='DualSlide__wrapper__bar'></div>
          </div>

          <div className='DualSlide__image'>
            <img
              className='DualSlide__image__img'
              alt='DualSlide__image__img'
              src='/images/DualSlide--5.jpg'
            />
          </div>
        </DualSlide>

        <div className='BodySpace'>
          <div className='container'>
            <p className='Products__p'>{t('pages.products.p')}</p>

            <div className='Products__content'>
              <h2 className='Products__h2'>{t('pages.products.content.h2')}</h2>

              <dl className='Products__dl'>
                {products.map((x, i) => (
                  <ProductItem key={i} x={x} />
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Products.propTypes = {}

export const getServerSideProps = async (ctx) => {
  let products

  try {
    products = await axios.get('/products')
  } catch (e) {}

  return {
    props: {
      products: get(products, 'data.data'),
    },
  }
}

export default Products
